<template lang="pug">
  .content(v-if="contents && contents.length" :class="[spacingTop, spacingBottom, layout]" ref="container")
    .container.mx-auto
        .content-wrap.clearfix
          .images(v-if="images && images.length" :class="imagePosition")
            PostImage(
              v-for="image in images" :key="image.id"
              :content="image"
              :count="images.length"
              :max-width="containerWidth"
              :shadow="shadow"
            )
          .contentbox
            Heading(:heading="heading.title" :subHeading="heading.sub_title")
            div(v-if="content && content.text" v-html="content.text")
</template>

<script>
import { debounce } from '@/helpers';

import Heading from './Heading';
import PostImage from './PostImage';

export default {
    name: 'Post',
    data() {
        return {
            containerWidth: undefined
        };
    },
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    components: {
        Heading,
        PostImage
    },
    computed: {
        contents() {
            return this.section.contents || [];
        },
        heading() {
            return this.contents.find(content => content.key === 'heading');
        },
        content() {
            return this.contents.find(content => content.key === 'content');
        },
        images() {
            return this.contents.filter(content => content.key === 'image');
        },

        layout() {
            let layout = 'layout-base';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'layout');
                if (setting && setting.value !== undefined) layout = setting.value;
            }
            return layout;
        },

        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },

        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        },

        imagePosition() {
            let position = 'left-float';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'image_position');
                if (setting && setting.value !== undefined) position = setting.value;
            }

            return position;
        },
        shadow() {
            let shadow = 'box-shadow-2';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'image_shadow');
                if (setting && setting.value !== undefined) shadow = setting.value;
            }

            return shadow;
        }
    },
    mounted() {
        if (this.imagePosition === 'left-float' || this.imagePosition === 'right-float') {
            this.containerWidth = 400;
        } else {
            const calculateMaxWidth = () => {
                if (this.$refs.container) {
                    const style = getComputedStyle(this.$refs.container);
                    this.containerWidth = this.$refs.container.clientWidth;
                    this.containerWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
                }
            };

            window.addEventListener('resize', debounce(calculateMaxWidth, 100));
            calculateMaxWidth();
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"
@import '@splidejs/splide/dist/css/themes/splide-default.min.css'
.content
    &.layout-01
        @apply text-center py-12
        //background-color: $weinankauf-honey
        //color: $weinankauf-green
        font-size: 17px
        &::v-deep
          h2
            font-size: 28px
    &.layout-02
        background-color: $weinankauf-honey
        .content-wrap
            @apply flex items-center justify-between flex-col
            @screen lg
                @apply flex-row
            .contentbox
                @apply my-8

            .images
                @apply mb-8
                padding-top: 0 !important
                @screen lg
                    @apply mb-0

                .post-image
                  @apply mb-0
                &.right-float
                  @apply order-2

    .content-wrap
        @apply mx-4
        @screen lg
            @apply mx-0
    &.infobox
        .content-wrap
            @apply border border-solid p-4 text-sm
            border-color: $maisonvin-border
            background-color: $maisonvin-grey
    @screen md
        .content-wrap
          .images.left-float
            @apply float-left block
            margin-right: 30px
            padding-top: 6px
          .images.right-float
            @apply float-right block
            margin-left: 30px
            padding-top: 6px
          .images.top-block
            @apply flex flex-col items-center
            margin-bottom: 25px
</style>
